import RenderDateField from "./DateField";
import RenderSelectField from "./SelectField";
import RenderNumberField from "./NumberField";
import RenderExternalField from "./ExternalField";
import RenderTextField from "./TextField";

export {
  RenderDateField,
  RenderSelectField,
  RenderNumberField,
  RenderExternalField,
  RenderTextField
};



// WEBPACK FOOTER //
// ./src/components/User/UserDetailsForm/renderFields/index.js